import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import update from 'immutability-helper';
import axios from 'axios'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../../shared/vars'

// Components
import CustomerSearch from './CustomerSearch';
import AssignedCustomers from './AssignedCustomers';

// State
import { updateTopTierCustomers } from "../../../../store/actions/topTier";
import { userTokenUpdate, userLogout } from "../../../../store/actions/user";

class AdminTopTierCustomersEdit extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: false,
            errors: {},
            customers: []
        }
    }

    componentDidMount(){
        this.loadTopTierCustomers(this.props.topTier.id);
    }

    loadTopTierCustomers(id){
        const { user } = this.props;
        this.setState({loading: true}, 
        () => {
            const token = user.token;
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
            return axios
                .get(REACT_APP_API_URL + "top-tier-customers/" + id, { headers: AUTH_HEADER })
                .then(response => {
                    if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                        this.props.userLogout("admin");
                    } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                        this.setState({ loading: false, error: response.data.message });
                    } else {
                        this.setState({
                            loading: false,
                            customers: response.data.top_tier_customers,
                            customersBackup: response.data.top_tier_customers,
                        });
                    }
                })
                .catch(err => {
                    if (err.response) {
                        this.setState({ loading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                    } else {
                        this.setState({ loading: false, error: err.message });
                    }
                });
        })
    }

    handleCustomerAdd = (customer) => {
        this.setState({
            customers: update(this.state.customers, {$push: [customer]})
        })
    }

    handleCustomerRemove = (index) => {
        this.setState({
            customers: update(this.state.customers, {$splice: [[index, 1]]})
        })
    }

    render(){
        return (
            this.state.loading ? <Fragment></Fragment> :
            <Fragment>
                <div className="customer-search">
                    <CustomerSearch
                        ref={"customersearch"}
                        currentlySelected={!!this.state.customers ? this.state.customers : []}
                        addCustomer={customer => this.handleCustomerAdd(customer)}
                        topTierId={this.props.topTier.id}
                    />

                    <AssignedCustomers 
                        customersList={this.state.customers}
                        isSearching={this.state.isSearching}
                        itemsPerPage={10}
                        handleCustomerRemove={index => this.handleCustomerRemove(index)}
                    />
                </div>
                {this.props.success && <div className="success msg_animate tt-success" style={{width: '100%'}}>Top tier customers successfully updated.</div>}
                <button className="btn" onClick={() => this.props.updateTopTierCustomers(this.props.topTier.id, this.state.customers)}>Update</button>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin,
        success: state.topTier.updateSuccess
    }
}

export default connect(mapStateToProps, { userTokenUpdate, userLogout, updateTopTierCustomers })(AdminTopTierCustomersEdit)


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/customers/AdminTopTierCustomersEdit.js